/**
 * Geçici ID yönetimi - Yeni kayıtlar için büyük negatif integer kullanır
 * Her entity tipi için ayrı aralık (çakışma önlenir), her biri ~10M ID
 */

const RANGE_SIZE = 10000000; // Her tip için ~10M ID
export const TEMP_ID_START = -99999999;
export const TEMP_ID_END = TEMP_ID_START - 7 * RANGE_SIZE; // Tüm tiplerin en alt sınırı
const counters = {
  car: TEMP_ID_START,
  detay: TEMP_ID_START - RANGE_SIZE,
  satis: TEMP_ID_START - 2 * RANGE_SIZE,
  islem: TEMP_ID_START - 3 * RANGE_SIZE,
  para: TEMP_ID_START - 4 * RANGE_SIZE,
  resim: TEMP_ID_START - 5 * RANGE_SIZE,
  ekimKanal: TEMP_ID_START - 6 * RANGE_SIZE,
};
const ends = {
  car: TEMP_ID_START - RANGE_SIZE,
  detay: TEMP_ID_START - 2 * RANGE_SIZE,
  satis: TEMP_ID_START - 3 * RANGE_SIZE,
  islem: TEMP_ID_START - 4 * RANGE_SIZE,
  para: TEMP_ID_START - 5 * RANGE_SIZE,
  resim: TEMP_ID_START - 6 * RANGE_SIZE,
  ekimKanal: TEMP_ID_START - 7 * RANGE_SIZE,
};

/**
 * Geçici ID mi kontrol et
 */
export function isTempId(id) {
  if (id == null || id === '') return false;
  const n = typeof id === 'number' ? id : parseInt(id, 10);
  return !isNaN(n) && n <= TEMP_ID_START && n > TEMP_ID_END;
}

function checkLimit(key) {
  if (counters[key] <= ends[key]) throw new Error('Geçici ID limiti aşıldı');
}

/**
 * Yeni geçici CAR_REF (cari kart ana kayıt)
 */
export function nextTempCarRef() {
  checkLimit('car');
  const id = counters.car;
  counters.car--;
  return id;
}

/**
 * Yeni geçici CD_REF (CARI_DETAY - arama vb.)
 */
export function nextTempDetayRef() {
  checkLimit('detay');
  const id = counters.detay;
  counters.detay--;
  return id;
}

/**
 * Yeni geçici ref - entity tipine göre
 */
export function nextTempRef(entityType = 'detay') {
  const key = entityType in counters ? entityType : 'detay';
  checkLimit(key);
  const id = counters[key];
  counters[key]--;
  return id;
}

/**
 * Modelde tüm geçici ref'leri gerçek ID ile değiştir
 * @param {object} model - Cari model objesi (iç içe olabilir)
 * @param {number} tempId - Eski geçici ID
 * @param {number} realId - Sunucudan gelen gerçek ID
 */
export function resolveTempRefInModel(model, tempId, realId) {
  if (!model || (typeof model !== 'object' && !Array.isArray(model))) return;

  const visit = (obj) => {
    if (!obj) return;
    if (Array.isArray(obj)) {
      obj.forEach(visit);
      return;
    }
    if (typeof obj !== 'object') return;

    for (const [k, v] of Object.entries(obj)) {
      if (k.endsWith('_REF') && v === tempId) {
        obj[k] = realId;
      } else if (k === 'cd_ref' && v === tempId) {
        obj.CD_REF = realId;
        delete obj.cd_ref;
      } else if (k === 'car_ref' && v === tempId) {
        obj.CAR_REF = realId;
        delete obj.car_ref;
      } else if (typeof v === 'object' || Array.isArray(v)) {
        visit(v);
      }
    }
  };

  visit(model);
}

/**
 * Array içinde tempId ile eşleşen kaydı bul (CD_REF veya cd_ref)
 */
export function findIndexByTempRef(arr, tempId) {
  if (!Array.isArray(arr)) return -1;
  return arr.findIndex(
    (r) => (r?.CD_REF ?? r?.cd_ref) === tempId
  );
}
